import { render } from "./IModal.vue?vue&type=template&id=ba76692a"
import script from "./IModal.vue?vue&type=script&lang=js"
export * from "./IModal.vue?vue&type=script&lang=js"
script.render = render

export default script